import React from 'react';

const AppointmentsSkeleton = ({ count = 8 }) => (
    <div className="appointments-table-wrap" aria-hidden="true">
        {Array.from({ length: count }).map((_, index) => (
            <div key={`appointments-skeleton-${index}`} className="appointments-skeleton-row">
                <div className="appointments-skeleton-block appointments-skeleton-block--checkbox" />
                <div className="appointments-skeleton-block appointments-skeleton-block--patient" />
                <div className="appointments-skeleton-block appointments-skeleton-block--time" />
                <div className="appointments-skeleton-block appointments-skeleton-block--doctor" />
                <div className="appointments-skeleton-block appointments-skeleton-block--contact" />
                <div className="appointments-skeleton-block appointments-skeleton-block--reminders" />
                <div className="appointments-skeleton-block appointments-skeleton-block--status" />
                <div className="appointments-skeleton-block appointments-skeleton-block--actions" />
            </div>
        ))}
    </div>
);

export default AppointmentsSkeleton;
